var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEcu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.59,
    height: 28.59,
    viewBox: "0 0 28.59 28.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_58",
    "data-name": "Groupe 58",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 10.483,
    height: 1.906,
    transform: "translate(8.895 26.684)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 3.812,
    height: 1.588,
    transform: "translate(19.378 25.096)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 3.494,
    height: 1.588,
    transform: "translate(5.4 25.096)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 1.906,
    height: 1.906,
    transform: "translate(23.19 23.19)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 6.989,
    height: 1.906,
    transform: "translate(8.895 23.19)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8",
    "data-name": "Trac\\xE9 8",
    d: "M86.1,24.088V22.312H84.328V20.536H82.552V8.1h1.776V6.328H86.1V4.552H96.76V2.776H91.432V1H86.1V2.776H82.552V4.552H80.776V8.1H79V18.76h1.776v3.552h1.776v1.776Z",
    transform: "translate(-77.123 0.836)",
    fill: "#e2b436"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 1.906,
    height: 1.906,
    transform: "translate(3.494 23.19)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 1.588,
    height: 1.906,
    transform: "translate(7.306 21.284)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 1.588,
    height: 3.494,
    transform: "translate(25.096 19.695)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 3.494,
    height: 1.588,
    transform: "translate(10.801 19.695)",
    fill: "#c2751d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 1.906,
    height: 1.588,
    transform: "translate(5.4 19.695)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 1.588,
    height: 3.494,
    transform: "translate(1.906 19.695)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 1.906,
    height: 1.906,
    transform: "translate(8.895 17.789)",
    fill: "#c2751d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 1.906,
    height: 10.801,
    transform: "translate(0 8.895)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 1.588,
    height: 1.906,
    transform: "translate(17.789 10.801)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9",
    "data-name": "Trac\\xE9 9",
    d: "M88.328,6.776V5H84.776V6.776H83v7.1h1.776v1.776h7.1V13.88h1.776V8.552H91.88V6.776Z",
    transform: "translate(-74.019 3.94)",
    fill: "#e2b436"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 1.906,
    height: 10.801,
    transform: "translate(26.684 8.895)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 1.906,
    height: 1.906,
    transform: "translate(21.284 8.895)",
    fill: "#c2751d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 3.494,
    height: 1.906,
    transform: "translate(14.295 8.895)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 1.588,
    height: 3.494,
    transform: "translate(25.096 5.4)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10",
    "data-name": "Trac\\xE9 10",
    d: "M98.984,4.776H97.208V3H93.656V4.776h1.776V6.552h1.776V17.208H95.432v1.776H93.656V20.76H90.1v1.776H83v1.776H93.656V22.536h3.552V20.76h1.776V17.208h1.776V6.552H98.984Z",
    transform: "translate(-74.019 2.388)",
    fill: "#e2b436"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 1.906,
    height: 1.588,
    transform: "translate(19.378 7.306)",
    fill: "#c2751d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11",
    "data-name": "Trac\\xE9 11",
    d: "M89.88,4.776V3H84.552V4.776H82.776V6.552H81V17.208h1.776v1.776h1.776V20.76H95.208V18.984h1.776V17.208H98.76V8.328H96.984V6.552H95.208V4.776Zm5.328,3.552v7.1H93.432v1.776H89.88v1.776H86.328V17.208H84.552V8.328h1.776V6.552h7.1V8.328Z",
    transform: "translate(-75.571 2.388)",
    fill: "#cf8934"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 1.588,
    height: 3.494,
    transform: "translate(1.906 5.4)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 1.906,
    height: 1.906,
    transform: "translate(23.19 5.4)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 5.083,
    height: 1.906,
    transform: "translate(14.295 5.4)",
    fill: "#c2751d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 1.906,
    height: 1.906,
    transform: "translate(23.19 3.494)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 3.812,
    height: 1.906,
    transform: "translate(19.378 3.494)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 1.906,
    height: 1.906,
    transform: "translate(3.494 3.494)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 3.812,
    height: 1.588,
    transform: "translate(19.378 1.906)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 5.083,
    height: 1.588,
    transform: "translate(14.295 1.906)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 3.494,
    height: 1.588,
    transform: "translate(5.4 1.906)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 10.483,
    height: 1.906,
    transform: "translate(8.895 0)",
    fill: "#231e2b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcu);
export default __webpack_public_path__ + "static/media/ecu.21cafd82dd27e81d838b69ac68fd7bf7.svg";
export { ForwardRef as ReactComponent };